import React from 'react';
export function Footer() {
  return <footer className="w-full border-t border-white/10 bg-ink-900 py-14 text-center" style={{
    paddingTop: "22px"
  }} data-id="element-80" data-mp="32wd2qgad7ltj">
      <div className="mx-auto max-w-3xl px-5" data-id="element-81" data-mp="3ghc0pwojutll">
        <p className="text-sm font-bold tracking-[0.28em] text-lilac-400" data-id="element-82" data-mp="32onkf2vm5o8y">
          🌿 REDONDOLAND™
        </p>
        <p className="mx-auto mt-5 max-w-xl text-[15px] leading-relaxed text-lilac-100" data-id="element-83" data-mp="36q93j5yqqyrl">
          The #1 pelvic floor transformation system for women — 100% PDF, 100% proven.
        </p>
        <p className="mx-auto mt-3 max-w-xl text-[15px] italic leading-relaxed text-muted" data-id="element-84" data-mp="37o6cv1anxdd">
          Because your body deserves a real system — not just another Kegel tip.
        </p>

        <ul className="mt-8 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-sm text-body" data-id="element-85" data-mp="3qcx8yck7oq3s">
          <li data-id="element-86" data-mp="29yxc5agnxgkr">
            <a href="mailto:redondoland1@gmail.com" className="transition-colors duration-150 ease-out hover:text-gold" data-id="element-87" data-mp="29ydvry6nv08u">
              📧 redondoland1@gmail.com
            </a>
          </li>
          <li data-id="element-88" data-mp="3lalf9cv8a1sw">
            <a href="https://instagram.com/redondoland" className="transition-colors duration-150 ease-out hover:text-gold" data-id="element-89" data-mp="3la29svmrl5vr">
              📲 @redondoland
            </a>
          </li>
          <li data-id="element-90" data-mp="3v8rl25k5ns31">
            <a href="https://redondoland.com" className="transition-colors duration-150 ease-out hover:text-gold" data-id="element-91" data-mp="3v9az3b6opwbs">
              🌐 redondoland.com
            </a>
          </li>
        </ul>

        <p className="mt-10 border-t border-white/10 pt-8 text-xs text-muted" data-id="element-92" data-mp="81pejgi0et8b">
          © Redondoland™ 2025 — All rights reserved.
        </p>
        <p className="mt-4 font-display text-base italic text-gold" data-id="element-93" data-mp="hstuaifiei47">
          💪 “Your next workout can be the best you've ever had.”
        </p>
      </div>
    </footer>;
}